export const PAGE_TARNSALATION_KEYS = {
    mytrips: {
        description: 'mytrips.traveler.app.banner.description',
        descriptionV1: 'mytrips.traveler.app.banner.description.v1',
        descriptionV2: 'mytrips.traveler.app.banner.description.v2',
        title: 'mytrips.traveler.app.banner.title',
        titleV1: 'mytrips.traveler.app.banner.title.v1',
        titleV2: 'mytrips.traveler.app.banner.title.v2',
        buttonLabel: 'mytrips.traveler.app.banner.button.label',
        closeButtonText: 'mytrips.traveler.app.modal.close.button.label'
    },
    confirmation: {
        description: 'confirmation.traveler.app.description',
        title: 'mytrips.traveler.app.banner.title',
        buttonLabel: 'mytrips.traveler.app.banner.button.label',
        closeButtonText: 'mytrips.traveler.app.modal.close.button.label',
    },
    inbox: {
        description: 'inbox.traveler.app.banner.description',
        descriptionV1: 'inbox.traveler.app.banner.description.v1',
        descriptionV2: 'inbox.traveler.app.banner.description.v2',
        title: 'inbox.traveler.app.banner.title',
        titleV1: 'inbox.traveler.app.banner.title.v1',
        titleV2: 'inbox.traveler.app.banner.title.v2',
        buttonLabel: 'inbox.traveler.app.banner.button.label',
        closeButtonText: 'inbox.traveler.app.modal.close.button.label',
    },
    serp: {
        description: 'serp.traveler.app.banner.description',
        title: 'serp.traveler.app.banner.title',
        buttonLabel: 'serp.traveler.app.banner.button.label',
        closeButtonText: 'serp.traveler.app.modal.close.button.label',
    },
    // using SERP keys for PDP as same text is required and once the test is completed this will be moved to surface
    pdp: {
        description: 'serp.traveler.app.banner.description',
        title: 'serp.traveler.app.banner.title',
    },
    homepage: {
        description: 'homepage.traveler.app.banner.description',
        modal_description: 'homepage.traveler.app.modal.description',
        modal_title: 'homepage.traveler.app.modal.title',
        title: 'homepage.traveler.app.banner.title',
        modal_buttonLabel: 'homepage.traveler.app.modal.button.label',
        buttonLabel: 'homepage.traveler.app.banner.button.label',
        closeButtonText: 'homepage.traveler.app.modal.close.button.label',
    },
    common: {
        ratings: 'traveler.app.banner.ratings',
        vaccineTitle: 'traveler.app.banner.vaccineTitle',
        vaccineDesc: 'traveler.app.banner.vaccineDesc',
        vaccineLearnMore: 'traveler.app.banner.vaccineLearnMore',
    },
    header: {
        buttonLabel: 'header.traveler.app.appDownloadButton.label'
    },
    desktopHeader: {
        buttonLabel: 'header.traveler.app.appDownloadButton.label'
    }
};
